const apiEnv = process.env.REACT_APP_API_ENV
  ? process.env.REACT_APP_API_ENV.toUpperCase()
  : "";

export const getEnv = (e) =>
  process.env[`REACT_APP_${e.toUpperCase()}${apiEnv}`];

export const api = { url: getEnv("api_url") };

export const CURRENT_ENV = getEnv("env");
export const CURRENT_OKTA_USER_SETTINGS = `${getEnv(
  "OKTA_ORGANIZATION_URI"
)}/enduser/settings`;

/**
 * Auth mode intends to determine which authentication mode will be used
 * Possible scenarios are:
 *  -> LCL: the user will hade credentials
 *  -> AAD: the user will connect through Azure AD
 */
export const AUTH_MODE_LCL = "LCL";
export const AUTH_MODE_AAD = "AAD";
export const app = {
  authMode: getEnv("auth_mode"),
  version: getEnv("version"),
  debug: process.env.NODE_ENV !== "production",
};

export const storage = getEnv("local_storage")
  ? window.localStorage
  : window.sessionStorage;
